export default function ({ $auth }) {
    $auth.onRedirect((to, from) => {
        if (from === '/en/Login') {
            return '/en/Search'
        }
        // TODO: handle other redirects
    })
}
